import { storeLaterViewVod } from "actions/post.action";
import PostLink from "components/boards/post/PostLink";
import VodImage from "components/boards/post/vod/VodImage";
import VodTypeIcon from "components/boards/post/vod/VodTypeIcon";
import { ACTCODE_THUMBNAIL } from "constant/log";
import { secondToTime } from "helpers";
import React, { Fragment, useCallback, useMemo } from "react";
import { isMobile } from "react-device-detect";
import { Trans, useTranslation } from "react-i18next";
import { READ_SUBSCRIPTION } from "constant/auth";
import { CATCH } from "constant/filetype";
import HomePinSection from "pages/station/home/section/HomePinSection";
import PostHomePin from "../PostHomePin";

const VodThumb = ({ vod, inflowPath, isPpvBj, height, pageType, onDestroyPin, authority, location, catchCreated = true, pageCreated = false}) => {
    const { t } = useTranslation();

    // vod 정보 조회
    const { ucc = {}, title_no: titleNo, auth_no, is_vod_pin: is_pin = false, pin = null } = vod;
    const { total_file_duration: titleFileDuration = null, ucc_type: uccType, file_type: fileType } = ucc;

    // 영상 시간 세팅
    const duration = useMemo(() => (titleFileDuration === null ? null : secondToTime(titleFileDuration / 1000)), [titleFileDuration]);

    // 360 도 영상 여부 세팅
    const is360Degree = useMemo(() => parseInt(uccType) === 22, [uccType]);

    // 나중에 다시 보기 클릭
    const handleLaterView = useCallback(
        (event) => {
            event.stopPropagation();
            event.preventDefault();
            storeLaterViewVod(titleNo);
        },
        [titleNo],
    );

    return (
        <Fragment>
            {isMobile && (
                // <span className="thum">
                <PostLink post={vod} className="thum" inflowPaths={inflowPath} catchCreated={catchCreated}>
                    {/* 다시보기, 하이라이트, 유료, 구독전용 등 vod 종류별 아이콘 노출 */}
                    <VodTypeIcon fileType={fileType} isPpvBj={isPpvBj} auth_no={auth_no}/>

                    {/* vod 썸네일 노출 */}
                    <VodImage vod={ucc} />

                    {/* vod 재생 시간 노출 */}
                    {fileType === CATCH && <em className="ic_catch"></em>}
                    {fileType !== CATCH && duration && <span className="time">{duration}</span>}
                </PostLink>
            )}

            {!isMobile && (
                <div className="thum">
                    <PostLink post={vod} inflowPaths={inflowPath} pageType={pageType} catchCreated={catchCreated}>
                        {/* vod 썸네일 노출 */}
                        <VodImage vod={ucc} />
                        {/* vod 재생 시간 노출 */}
                        {fileType !== CATCH && duration && <span className="time">{duration}</span>}
                        
                        {/* 캐치 마크 노출 */}
                        {fileType === CATCH && <span className="ic_catch"></span>}

                        {/* 다시보기, 하이라이트, 유료, 구독전용 등 vod 종류별 아이콘 노출 */}
                        <VodTypeIcon fileType={fileType} isPpvBj={isPpvBj} auth_no={auth_no}/>

                        {location !== 'home' && <PostHomePin post={vod} authority={authority} location={location} created={pageCreated} />}
                        {location === 'home' && is_pin && <HomePinSection pinItem={vod} className='pin' onDestroyPin={onDestroyPin} boardTypeName={'VOD'} location={location} created={pageCreated} />}

                        {/* 나중에 보기 노출 */}
                        {fileType !== CATCH && ( 
                            <button type="button" className="btn-later" tip={t("나중에 보기")} onClick={handleLaterView}>
                                <span>
                                    나중에 보기
                                </span>
                            </button>
                        )}

                        {/* 360 도 영상 아이콘 노출 */}
                        {is360Degree && (
                            <button type="button" className="btn-360deg">
                                <span>360도</span>
                            </button>
                        )}
                    </PostLink>
                </div>
            )}
        </Fragment>
    );
};

export default VodThumb;
